import ApiActivacion from "@/services/conf/api/ApiActivacion.conf";
import ActivacionUrl from "@/utils/apiUrl/activacion.url";
import httpstatus from "@/utils/httpstatus";
import httpErrorMessage from "@/utils/httpErrorMessage";
import utilsValidate from "@/utils/responseValid"


export default {

    async putVerificar(payload){
        try {
            let verificar = ApiActivacion.getConfiguration();
            verificar.url = ActivacionUrl.APP_VERIFICAR;

            verificar.body = payload;

            let response = await verificar.put();
            // console.log('response service', response);

            /*Muestra el error de la api */
            if(response.data && response.data.status != 200){
                throw new Error(response.data.message ? response.data.message : httpErrorMessage.DEFAULT_ERROR)
            /*Muetra el error de la libreria hcRequest */
            }else if(response.status != 200){
                throw new Error(response.statusText ? response.statusText : httpErrorMessage.CONECTION_ERROR)
            }
            return response.data 
            
        } catch (error) {
            throw new Error(error.message)
        }
    },






}